// vendor
import { memo } from 'react';

function BlockUpdates({ children }) {
  return children;
}

export default memo(BlockUpdates, () => true);
